<template>
</template>

<script>
    export default {
        props: ['type', 'msg'],
        created () {
            if(this.type == "ResetPassword"){
                if (sessionStorage.ResetPassword == "true") {
                    this.$toast.success(this.msg, { timeout: 2038, });
                    sessionStorage.removeItem('ResetPassword');
                }
            }
        },
    }
</script>

</style>